<script>
  import { createEventDispatcher, setContext } from 'svelte'
  import { writable } from 'svelte/store'
  import { clickOutside } from './../utils.js'
  import filterClasses, { cssPrefix } from '../helper-classes.js'

  export let fullWidth = false

  export let id = null
  export let style = null
  export let helperClass = null
  let importedClasses = ''
  export { importedClasses as class }
  export let classPermissiveMode = false
  if (helperClass) {
    console.debug("[DS:deprecation] please replace 'helperClass' prop by 'class'")
    if (!importedClasses) {
      importedClasses = helperClass
    }
  }
  const classes = [`${cssPrefix}dropdown-wrapper`]
  if (importedClasses) classes.push(...filterClasses(importedClasses, classPermissiveMode))

  const dispatch = createEventDispatcher()

  const opened = writable(false)

  if (fullWidth) classes.push('is-fullwidth')

  const handleClickOutside = () => opened.set(false)

  export const toggle = event => {
    opened.update($state => {
      dispatch(!$state ? 'open' : 'close', event ? event.detail : null)
      return !$state
    })
  }

  setContext('currentDropdown', { toggle, opened, close })
</script>

<svelte:window
  on:keydown={e => {
    if (e.key === 'Escape') opened.set(false)
  }}
/>

<span
  class={classes.join(' ')}
  {style}
  use:clickOutside
  on:click_outside={handleClickOutside}
  {id}
  aria-expanded={$opened}
>
  <slot />
</span>
